// FromThisToThis.js
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

// REPLACE imgBox with these two styles:
const imgWrapStyle = {
  display: 'inline-block',
  borderRadius: '0.5rem',
  overflow: 'hidden',
  maxWidth: '100%'
};

const imgContainStyle = {
  display: 'block',
  width: 'auto',
  height: 'auto',
  maxWidth: '100%'
};

const FromThisToThis = ({
  title = "Move from burdened to empowered",
  subtitle = "from legal rights, to automation, get your career oriented",
  leftImageUrl = "/images/burden-chaos.jpg",
  centerText = "The ArtLab way, taking on fun challenging exercises in a group with friends",
  rightImageUrl = "/images/empowered-n8n-art.jpg"
}) => (
  <section className="py-5">
    <Container>
      <Row className="mb-4">
        <Col xs={12} className="text-center">
          <h1 className="fw-bold mb-2" style={{ whiteSpace: 'pre-line' }}>{title}</h1>
          <p className="text-muted mb-0">{subtitle}</p>
        </Col>
      </Row>

      <Row className="g-4 justify-content-between">
        {/* Left card: image (chaos) */}
        <Col xs={12} md={4}>
          <Card className="h-100 border-0 shadow-sm">
                <div style={imgWrapStyle}>
                <img src={leftImageUrl} alt="Before: overwhelmed by chaos" style={imgContainStyle} />
                </div>
          </Card>
        </Col>

        {/* Center card: ArtLab way text */}
        <Col xs={12} md={4}>
          <Card className="h-100 border-0 shadow-sm d-flex">
            <Card.Body className="d-flex flex-column justify-content-center text-center">
              <h2 className="h4 fw-bold mb-3">The ArtLab Way →</h2>
              <p className="mb-0">{centerText}</p>
            </Card.Body>
          </Card>
        </Col>

        {/* Right card: image (n8n automation) */}
        <Col xs={12} md={4}>
          <Card className="h-100 border-0 shadow-sm">
                <div style={imgWrapStyle}>
                <img src={rightImageUrl} alt="After: relaxed with n8n automation producing art" style={imgContainStyle} />
                </div>

          </Card>
        </Col>
      </Row>
    </Container>
  </section>
);

export default FromThisToThis;
